import React, { Component, useState } from "react";
import CartContext from "./CartContext";
import { Products } from "./Products";
import { Showcase } from "./Showcase";
import { Pricing } from "./Pricing";
import { Services } from "./Services";
import Slider from "react-slick";

import { Form, Row, Col, Table, Carousel, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HomeCarousels } from "./HomeCarosels";

export class ProductHightlights extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      RetailPosBaseCost: 999,
      TotalRetailPosUser: 1,
      RetailPosLicensePeriod: "OneYear",
      RetailPosAdditionalUserCost: 999,
      SixMonths: 6,
      OneYear: 12,
    };
  }

  GetProductRouteLink = (product) => {
    switch (product.productType) {
      case this.context.ProductType.Retail_POS:
        return "POS";
      case this.context.ProductType.Restaurant_POS:
        return "PosRestaurant";
      case this.context.ProductType.ECommerce:
        return "ECommerce";
      // case this.context.ProductType.ECommerce_B2C_Restaurant:
      //   return "ECommerceB2CRestaurant";
      // case this.context.ProductType.ECommerce_B2B:
      //   return "ECommerceB2B";
      case this.context.ProductType.KIOSK_ECommerce:
        return "Kiosk";
      case this.context.ProductType.QRCODE_ECommerce:
        return "QRCodePos";
      // case this.context.ProductType.Retail_ERP:
      //   return "ErpRetail";
      // case this.context.ProductType.Restaurant_ERP:
      //   return "ErpRestaurant";
      case this.context.ProductType.ERP:
        return "ERP";
      case this.context.ProductType.SupplyChain:
        return "SupplyChain";

      case this.context.ProductType.ProductionManagement:
        return "Production";
      case this.context.ProductType.WarehouseManagement:
        return "Warehouse";
      // case this.context.ProductType.ServiceManagement:
      //   return "ErpRetail";
      case this.context.ProductType.CRM:
        return "CrmSales";
      case this.context.ProductType.HRM:
        return "HRM";
      case this.context.ProductType.Finance:
        return "Accounting";
    }
  };

  render() {
    return (
      <>
        <div class="mx-0 py-2 bg-light">
          <div class=" py-5  text-center mb-3">
            <div class="mb-2 text-center">
              <h1 class="display-6 text-uppercase text-primary mb-0">
                <b>Products</b>
              </h1>
            </div>
            <>
              <Row className="gx-3 gy-4 justify-content-center bg-light ">
                {this.context.prods
                  .sort((a, b) => (a.seqNo > b.seqNo ? 1 : -1))
                  .map((product, index) => (
                    <Col
                      key={product.name + index}
                      lg={5}
                      className="px-2 mb-3"
                    >
                      <Card className="h-100 shadow-sm border-0 border-dark rounded-4 text-center p-3 m-3 CornersRoundedMedium">
                        <Card.Body className="border-0 border-dark my-0 py-0">
                          {/* Product Name */}
                          <h4 className="fw-bold text-dark ">{product.name}</h4>
                          <h6 className="fw-bold text-primary ">
                            {product.shortDescription}
                          </h6>
                          {/* Description */}
                          <p
                            className="text-muted mb-1"
                            style={{
                              textAlign: "justify",
                              minHeight: "80px",
                              fontSize: "14px",
                            }}
                          >
                            {product.description}
                          </p>

                          {/* Image */}
                          <a href={"/" + this.GetProductRouteLink(product)}>
                            {window.innerWidth > 1200 ? (
                              <>
                                <Card.Img
                                  className="my-0 border-0 w-100"
                                  variant="top"
                                  src={
                                    this.context.GetEcSettingValueByName(
                                      "StorageBlobImageUrl"
                                    ) + `${product.imgFileName}`
                                  }
                                  height="300"
                                  style={{ objectFit: "contain" }}
                                  alt={product.name}
                                />
                              </>
                            ) : (
                              <>
                                <Card.Img
                                  className="my-0 border-0 w-100"
                                  variant="top"
                                  src={
                                    this.context.GetEcSettingValueByName(
                                      "StorageBlobImageUrl"
                                    ) + `${product.imgFileName}`
                                  }
                                  // height="300"
                                  style={{ objectFit: "contain" }}
                                  alt={product.name}
                                />
                              </>
                            )}
                          </a>

                          {/* Pricing */}
                          {/* <h5 className="text-primary mt-3">
                            <strong>Starts at</strong>
                            <br />
                            {product.monthlyCost.toLocaleString("en-IN", {
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0,
                            })}{" "}
                            / Month
                          </h5> */}

                          {/* Buttons */}
                        </Card.Body>
                        <Card.Footer className="bg-white border-0">
                          <Row className="m-0 p-0 border-0 border-primary">
                            <Col sm={6} className="mb-1">
                              <a href={"/" + this.GetProductRouteLink(product)}>
                                <Button
                                  className="w-100"
                                  variant="outline-primary"
                                >
                                  Learn More
                                </Button>
                              </a>
                            </Col>
                            <Col sm={6}>
                              <Button
                                as={Link}
                                className="w-100"
                                variant="warning"
                                to="/Checkout"
                                onClick={() => {
                                  if (
                                    this.context.userData.loginStatus !==
                                    "active"
                                  ) {
                                    this.context.ShowUserLoginNew(true);
                                  }
                                  this.context.SetSelectedProduct(product);
                                }}
                              >
                                Trial / Buy
                                {/* {product.productType ==
                                  this.context.ProductType.Retail_ERP ||
                                product.productType ==
                                  this.context.ProductType.Restaurant_ERP ||
                                product.productType ==
                                  this.context.ProductType.ERP ||
                                product.productType ==
                                  this.context.ProductType.SupplyChain ||
                                product.productType ==
                                  this.context.ProductType.CRM ||
                                product.productType ==
                                  this.context.ProductType.CRM ||
                                product.productType ==
                                  this.context.ProductType.WebSite ? (
                                  <>Buy</>
                                ) : (
                                  <>Free / Buy</>
                                )} */}
                              </Button>
                            </Col>
                          </Row>
                        </Card.Footer>
                      </Card>
                    </Col>
                  ))}
              </Row>
            </>
          </div>
        </div>
      </>
    );
  }
}
